import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getEquipmentEntriesSelector = createSelector(
  equipmentEntries => equipmentEntries.equipmentEntries,
  (equipmentEntriesById) => getArrayOfObjectValues(equipmentEntriesById)
);